import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type { FC, PropsWithChildren } from 'react';
import { EMBED_URL_CACHE_MS, EMBED_URL_QUERY_KEY } from '~/constants';
import { Logger } from '~/lib/logger';

const logger = new Logger('ReactQueryProvider');

const queryClient = new QueryClient();

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: 'supplier-portal-query-cache',
});

export const ReactQueryProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: EMBED_URL_CACHE_MS,
        dehydrateOptions: {
          shouldDehydrateQuery: (query) => {
            const isPersistable = JSON.stringify(query.queryKey) === JSON.stringify(EMBED_URL_QUERY_KEY);

            if (isPersistable) {
              logger.info(`[Cache:Persist] Dehydrating query "${query.queryKey.join('/')}" to localStorage`);
            }

            return isPersistable;
          },
        },
      }}
      onSuccess={() => {
        logger.info('[Cache:Restore] Successfully restored persisted queries from localStorage');
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
};
